import React, { useState, useEffect } from 'react';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, Lock, ArrowLeft } from 'lucide-react';
import AuthForm from './AuthForm';
import { isClientUser } from '../utils/userRole';
import '../Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const savedEmail = localStorage.getItem('email');
    const savedPassword = localStorage.getItem('password');
    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    try {
      const auth = getAuth();
      
      
      
      await signInWithEmailAndPassword(auth, email, password);
      
      if (rememberMe) {
        localStorage.setItem('email', email);
        localStorage.setItem('password', password);
      } else {
        localStorage.removeItem('email');
        localStorage.removeItem('password');
      }
      
      navigate('/dashboard');
    } catch (error) {
      console.error('Erreur de connexion:', error);
      setError('Email ou mot de passe incorrect');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthForm title="Connexion Intervenant">
      <Link to="/" className="back-button">
        <ArrowLeft size={18} />
        Retour
      </Link>
      
      <form onSubmit={handleSubmit} className="auth-form">
        <div className="input-group">
          <label htmlFor="email" className="input-label">
            <Mail className="input-icon" />
            <span>Email professionnel</span>
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input-field"
            placeholder="votre.email@entreprise.fr"
          />
        </div>

        <div className="input-group">
          <label htmlFor="password" className="input-label">
            <Lock className="input-icon" />
            <span>Mot de passe</span>
          </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="input-field"
            placeholder="Votre mot de passe"
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="remember-me">
          <input
            type="checkbox"
            id="rememberMe"
            className="remember-me-checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          <label htmlFor="rememberMe" className="remember-me-label">
            Se souvenir de moi
          </label>
        </div>

        <button 
          type="submit" 
          disabled={isLoading}
          className="auth-button"
        >
          {isLoading ? 'Connexion...' : 'Se connecter'}
        </button>

        <div className="auth-footer">
          <Link to="/forgot-password" className="footer-link">
            Mot de passe oublié ?
          </Link>
        </div>
      </form>
    </AuthForm>
  );
}

export default Login;
